export const plural = (key, count, params, _locale, getTranslation) => {
      const translation = getTranslation(key, params);
      if (!translation) {
        return null;
      }
      const forms = translation.toString().split("|");
      return (count < forms.length ? forms[count].trim() : forms[forms.length - 1].trim()).replace("{count}", count.toString());
    };